// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"risk-matrix-type__visuallyhidden--UaYDX","focusable":"risk-matrix-type__focusable--WocDm","container":"risk-matrix-type__container--VOYVf"};